function isSelected(day, value, dayStaticClass) {
    return value.isSame(day, "day");
}

export function beforeToday(day) {
    let isBefore = day.isBefore(new Date(), "day");
    //
    return isBefore;
}

function isToday(day) {
    return day.isSame(new Date(), "day");
}
export function afterToday(day) {
    return day.isAfter(new Date(), "day");
}
export function beforeSpecificDate(day, specificDate) {
    return day.isBefore(specificDate, "day");
}

export default function dayStyles({ day, selectedDate, specificDate }) {
    if (afterToday(day)) return "before";
    if (isSelected(day, selectedDate)) return "selected";
    if (isToday(day)) return "today";
    if (beforeSpecificDate(day, specificDate)) return "before";
    return "";
}
